import { render, staticRenderFns } from "./DialogUploadDocument.vue?vue&type=template&id=678b00c8&"
import script from "./DialogUploadDocument.vue?vue&type=script&lang=js&"
export * from "./DialogUploadDocument.vue?vue&type=script&lang=js&"
import style0 from "./DialogUploadDocument.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports